import styled from "styled-components";
import { TicketCommunication } from "../../../globals/interfaces";
import { formatDatetime, formatEmail } from "../../../utils";

export default function Comment ({
    item,
    isUser
}: {
    item: TicketCommunication;
    isUser: boolean;
}) {
    return (
        <Container isUser={isUser}>
            <Name>{isUser ? 'Me' : formatEmail(item.createdBy)}</Name>
            <p>{item.message}</p>
            <Date>{formatDatetime(item.createdAt)}</Date>
        </Container>
    );
}

const Container = styled.div<{ isUser: boolean }>`
    p {
        margin-bottom: 0px;
        padding-bottom: 0px;
        text-align: ${p => p.isUser ? 'right' : 'left'}
    }
`;

const Date = styled.p`
    font-size: 10px;
`;

const Name = styled.p`
    font-weight: bold;
    font-style: italic;
`;